import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ModuleEnum } from '../_utils/unums/module.enum';
import { Storage } from '@ionic/storage';
import { ModuleService } from './module.service';


@Injectable({
  providedIn: 'root'
})
export class UserAssessmentService {
  private readonly baseUrl: string;

  constructor(
    private http: HttpClient,
    private storage: Storage,
    private moduleService: ModuleService
  ) {
    this.baseUrl = `${environment.apiUrl}/user-assessments`;
  }

  public getUserAssessment = (userId: string, assessmentId: string, module?: string): Observable<any[]> => {
    const params: any = { userId, assessmentId };
    if (module) {
      params.module = module;
    }
    return this.http.get<any>(`${this.baseUrl}`, { params });
  };


  public getUserAssessmentByKey = (key: string): Observable<any> =>
    this.http.get<any>(`${this.baseUrl}/key/${encodeURIComponent(key)}`);

  public getUserAssessmentsByUser = (userId: string): Observable<any[]> =>
    this.http.get<any[]>(`${this.baseUrl}`, { params: { userId } });

  public updateUserAssessment = (id: string, payload: any): Observable<void> =>
    this.http.put<void>(`${this.baseUrl}/${encodeURIComponent(id)}`, payload);

  public insertUserAssessment = (payload: any): Observable<string> =>
    this.http.post(`${this.baseUrl}`, payload, { responseType: 'text' });

  public hasPreTraining = async (module: ModuleEnum | string): Promise<boolean> => {
    const user = await this.storage.get('user');
    const assessmentId = await this.moduleService.getAssessmentIdByProperty(module, 'pre_training', 'settings.assessments.preTraining');
    const [assessment] = await lastValueFrom(this.getUserAssessment(user.uid, assessmentId, module));
    return !!assessment;
  };

  public hasPostTraining = async (module: ModuleEnum | string): Promise<boolean> => {
    const user = await this.storage.get('user');
    const assessmentId = await this.moduleService.getAssessmentIdByProperty(module, 'post_training', 'settings.assessments.postTraining');
    const [assessment] = await lastValueFrom(this.getUserAssessment(user.uid, assessmentId, module));
    return !!assessment;
  };


}
